import Box from '@mui/material/Box'
import styled from 'styled-components'

export const ActiveConnectionRoot = styled(Box)`
  padding: 16px 20px;
  max-width: 365px;

  h6 {
    font-weight: 600;
    font-size: 16px;
  }

  > p {
    font-weight: 400;
    font-size: 13px;
    line-height: 20px;
  }

  b {
    font-weight: 600;
  }

  .MuiAlert-root {
    color: #000000;
    background: #f4f4f4;
    font-weight: 500;
    font-size: 11px;
    line-height: 16px;
    align-items: center;
    padding-left: 13px;
    padding-right: 13px;

    p {
      font-size: 11px;
    }

    svg {
      color: black;
    }
  }

  .MuiButton-contained {
    color: white;
    background: #041f3d;

    :hover {
      background: #041f3dd4;
    }
  }
`
